document.addEventListener('DOMContentLoaded', function() {
  // Handle add to cart form submissions
  document.addEventListener('submit', function(e) {
    if (e.target.id && e.target.id.startsWith('AddToCartForm')) {
      e.preventDefault();
      
      const formData = new FormData(e.target);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(item => {
        // Open cart drawer
        const cartDrawer = document.getElementById('CartDrawer');
        if (cartDrawer) {
          cartDrawer.classList.add('drawer--is-open');
          document.documentElement.classList.add('js-drawer-open');
          document.documentElement.classList.add('js-drawer-open--right');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  });

  // Handle cart drawer close button
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    const closeButton = cartDrawer.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        cartDrawer.classList.remove('drawer--is-open');
        document.documentElement.classList.remove('js-drawer-open');
        document.documentElement.classList.remove('js-drawer-open--right');
      });
    }
  }
}); 